import { Plus, X, Camera } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { MEALS } from "@/lib/nutri";

const EntryRow = ({ e, onChanged }) => {
  const remove = async () => {
    try {
      await api.delete(`/nutri/entries/${e.id}`);
      onChanged();
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  return (
    <div data-testid={`entry-row-${e.id}`} className="flex items-center gap-3 py-2.5">
      <div className="min-w-0 flex-1">
        <p className="flex items-center gap-2 truncate text-sm">
          {e.source === "photo" && <Camera size={12} className="shrink-0 text-[#98bfa2]" />}{e.name}
        </p>
        <p className="font-mono text-[11px] text-[#a3b1aa]">{Math.round(e.grams)} g · P {e.protein} · C {e.carbs} · G {e.fat}</p>
      </div>
      <span className="font-mono text-sm">{Math.round(e.kcal)} kcal</span>
      <button data-testid={`delete-entry-${e.id}`} onClick={remove} className="p-1 text-[#a3b1aa] hover:text-[#f0a78f]" aria-label="Elimina"><X size={14} /></button>
    </div>
  );
};

export const MealList = ({ entries, onAdd, onChanged }) => {
  const list = Array.isArray(entries) ? entries : [];
  return (
    <section data-testid="meal-list" className="space-y-4">
      {MEALS.map((m) => {
        const items = list.filter((e) => e.meal === m.key);
        const kcal = items.reduce((s, e) => s + e.kcal, 0);
        return (
          <div key={m.key} data-testid={`meal-${m.key}`} className="border border-[rgba(152,191,162,0.15)] bg-[#0b120e] p-5">
            <div className="flex items-center justify-between">
              <div className="flex items-baseline gap-3">
                <h3 className="font-display text-2xl font-900 uppercase">{m.label}</h3>
                <span className="font-mono text-xs text-[#a3b1aa]" data-testid={`meal-kcal-${m.key}`}>{Math.round(kcal)} kcal</span>
              </div>
              <button data-testid={`add-food-${m.key}`} onClick={() => onAdd(m.key)}
                className="flex items-center gap-1.5 rounded-full bg-[#98bfa2] px-3 py-1.5 font-mono text-xs font-semibold uppercase text-[#050807] hover:bg-[#c4dcca]">
                <Plus size={14} /> Aggiungi
              </button>
            </div>
            {items.length > 0 && <div className="mt-3 divide-y divide-white/5 border-t border-white/5">{items.map((e) => <EntryRow key={e.id} e={e} onChanged={onChanged} />)}</div>}
          </div>
        );
      })}
    </section>
  );
};
